import { defineStore } from 'pinia';

const PROVIDER_LABELS = {
  google: 'Google',
  microsoft: 'Microsoft',
  gitlab: 'GitLab',
};

function signInState(fullPath, extraQuery) {
  let next = fullPath;
  if (extraQuery) {
    const params = new URLSearchParams(extraQuery);
    const join = next.includes('?') ? '&' : '?';
    next = `${next}${join}${params.toString()}`;
  }
  return encodeURIComponent(JSON.stringify({ next }));
}

function defaultProviderState() {
  return {
    connected: false,
    statusLoaded: false,
  };
}

const useOAuthStore = defineStore('oauthStore', {
  state: () => ({
    providers: {
      google: defaultProviderState(),
      microsoft: defaultProviderState(),
      gitlab: defaultProviderState(),
    },
  }),

  actions: {
    isProviderConnected(provider) {
      return this.providers[provider]?.connected ?? false;
    },
    isProviderStatusLoaded(provider) {
      return this.providers[provider]?.statusLoaded ?? false;
    },
    providerConnectLabel(provider) {
      const label = PROVIDER_LABELS[provider] || provider;
      return `Connect ${label}`;
    },
    startSignIn(provider, fullPath, extraQuery) {
      window.location.href = `/api/auth/oauth/${provider}/sign_in?state=${signInState(fullPath, extraQuery)}`;
    },
    fetchConnectionStatus(provider) {
      return this.$http.get(`/api/auth/oauth/${provider}/status`)
        .then(response => {
          const connected = Boolean(response.data.connected);
          this.providers[provider].connected = connected;
          return connected;
        })
        .finally(() => {
          this.providers[provider].statusLoaded = true;
        });
    },
  },
});

export default useOAuthStore;
